import React from 'react';
import { CommonIcon } from '../../../../icons/behavior/CommonIcon';
import { ConcerningIcon } from '../../../../icons/behavior/ConcerningIcon';
import { IrregularIcon } from '../../../../icons/behavior/IrregularIcon';
import { NormalIcon } from '../../../../icons/behavior/NormalIcon';
import { RareIcon } from '../../../../icons/behavior/RareIcon';
import { UnusualIcon } from '../../../../icons/behavior/UnusualIcon';
import { CamelizedBehaviorArticleResponse } from '../../../../types/api';
import { Typography } from '../../../../wag-react/components/Typography';
import { Grid } from '../../../../wag-react/core-components/grid';
import { Flex } from '../../../../wag-react/next-components/Flex';
import { theme } from '../../../../wag-react/themes/base-theme';
const CommonIconMapping = {
  Common: CommonIcon,
  Unusual: UnusualIcon,
  Rare: RareIcon
};
const ConcernIconMapping = {
  Normal: NormalIcon,
  Irregular: IrregularIcon,
  Concerning: ConcerningIcon
};
export type BehaviorDetailsProps = CamelizedBehaviorArticleResponse;
export const BehaviorDetails = ({
  details
}: BehaviorDetailsProps) => {
  const HowCommonIcon = CommonIconMapping[details.howCommon] || null;
  const HowConcerningIcon = ConcernIconMapping[details.howConcerning] || null;
  return <Grid gridAutoFlow="column" gridTemplateColumns="repeat(2, max-content)" gridGap={['32px', '104px']} px={['16px', '32px']} data-sentry-element="Grid" data-sentry-component="BehaviorDetails" data-sentry-source-file="index.tsx">
      {HowCommonIcon && <Flex alignItems="center" gridGap="16px">
          <HowCommonIcon fontSize="32px" />
          <Typography fontFamily="muliSemiBold" color={theme.colors.darkGray}>
            {details.howCommon}
          </Typography>
        </Flex>}
      {HowConcerningIcon && <Flex alignItems="center" gridGap="16px">
          <HowConcerningIcon fontSize="32px" />
          <Typography fontFamily="muliSemiBold" color={theme.colors.darkGray}>
            {details.howConcerning}
          </Typography>
        </Flex>}

    </Grid>;
};